import { error, success } from "@redux-requests/core";

const initialState = {
	originalData: {},
	allFilterOptions: {},
	selectedFilterOptions: {},
	currentData: {},
	savedAnalyticFilters: {},
	loading: false,
};

const getProjectsByCjms = ({ projects, cjms }) => {
	const projectIds = [];
	cjms?.forEach((cjm) => {
		cjm?.projectIds?.forEach((projectId) => {
			if (!projectIds?.includes(projectId)) projectIds.push(projectId);
		});
	});

	return projects?.filter((project) => projectIds.includes(project?.id));
};

const roiAnalysisReducer = (state = initialState, action) => {
	const responseData = action?.response?.data;

	switch (action.type) {
		case success("GET_ROI_ANALYSIS_DATA"): {
			const { isExportMode } = action?.meta?.requestAction?.params;

			if (isExportMode) {
				const { filterBy, cjms, projects, startDate, endDate } = state?.savedAnalyticFilters;
				const currentProjects = responseData?.projects.filter((p) => projects?.includes(p?.id));
				return {
					...state,
					originalData: responseData,
					allFilterOptions: { filterBy: ["cjms", "projects"], cjms: responseData?.cjms, projects: responseData?.projects },
					selectedFilterOptions: {
						filterBy,
						cjms: responseData?.cjms.filter((c) => cjms?.includes(c?.id)),
						projects: currentProjects,
						date: { startDate, endDate },
					},
					currentData: {
						projects: currentProjects,
					},
					loading: false,
				};
			}

			return {
				...state,
				originalData: responseData,
				allFilterOptions: { filterBy: ["cjms", "projects"], cjms: responseData?.cjms, projects: responseData?.projects },
				selectedFilterOptions: {
					filterBy: "projects",
					cjms: responseData?.cjms,
					projects: responseData?.projects,
					date: { startDate: new Date(new Date().getFullYear(), 0, 1), endDate: new Date() },
				},
				currentData: {
					projects: responseData?.projects,
				},
				loading: false,
			};
		}
		case error("GET_ROI_ANALYSIS_DATA"):
			return state;
		case "APPLY_FILTER_ROI_ANALYSIS": {
			const { dataAttribute, selectedItems } = action?.payload;

			switch (dataAttribute) {
				case "filterBy": {
					return {
						...state,
						selectedFilterOptions: { ...state?.selectedFilterOptions, filterBy: selectedItems },
						loading: false,
					};
				}
				case "projects": {
					return {
						...state,
						selectedFilterOptions: {
							...state.selectedFilterOptions,
							projects: selectedItems,
						},
						currentData: {
							projects: selectedItems,
						},
					};
				}
				case "cjms": {
					return {
						...state,
						selectedFilterOptions: {
							...state.selectedFilterOptions,
							cjms: selectedItems,
						},
						currentData: {
							projects: getProjectsByCjms({ projects: state?.originalData?.projects, cjms: selectedItems }),
						},
					};
				}
				case "date": {
					const checkStartEndDate = (date, project) => {
						if (date?.startDate === "" || date?.endDate === "" || project?.startDate === "" || project?.endDate === "") return true;
						const range1 = { start: new Date(date?.startDate), end: new Date(date?.endDate) };
						const range2 = { start: new Date(project?.startDate), end: new Date(project?.endDate) };
						if (range1?.start <= range2?.end && range2?.start <= range1?.end) {
							return true;
						}
						return false;
					};

					return {
						...state,
						selectedFilterOptions: {
							...state?.selectedFilterOptions,
							date: selectedItems,
						},
						currentData: {
							projects: state?.selectedFilterOptions?.projects?.filter((selectedProject) => checkStartEndDate(selectedItems, selectedProject)),
						},
					};
				}
				default:
					return state;
			}
		}
		case success("GET_ANALYTICS_FILTERS"): {
			return {
				...state,
				savedAnalyticFilters: responseData,
			};
		}
		default:
			return state;
	}
};
export default roiAnalysisReducer;
